var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-grid m-grid--hor m-grid--root m-page"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body"},[_c('LeftMenu'),_vm._v(" "),_c('div',{staticClass:"m-grid__item m-grid__item--fluid m-wrapper"},[_c('div',{staticClass:"m-content"},[_c('Stats'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('Services'),_vm._v(" "),_c('Properties')],1)],1)])],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dashboard/HomePage.vue?vue&type=template&id=34ef4ed9&
// module id = null
// module chunks = 